import { Theme } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'

const bp = 'sm'

interface SideModalStyleProps {
  minWidth: number
}

const useStyles = makeStyles<Theme, SideModalStyleProps>(theme => ({
  root: {
    position: 'absolute',
    top: '0',
    right: '0',
    zIndex: 1,
    border: '1px solid #E4E8EA',
    boxSizing: 'border-box',
    height: '100svh',
    padding: '1rem',
    paddingRight: '1.5rem',
    backgroundColor: 'white',
    minWidth: ({ minWidth }) => minWidth,

    [theme.breakpoints.down(bp)]: {
      left: '0',
      bottom: '0',
      border: 'none',
      minWidth: '100vw !important',
      height: 'calc(100svh - 64.5px)',
      /* mobile viewport bug fix */
      minHeight: '-webkit-fill-available'
    },

    '& .crop-left-line': {
      position: 'absolute',
      zIndex: 1,
      heigth: '100%',
      top: 0,
      left: 0,
      bottom: 0,
      width: 6,
      cursor: 'ew-resize',
      borderLeft: 'solid 1px #E4E8EA'
    }
  },

  close: {
    position: 'absolute',
    top: 10,
    right: '1rem',
    left: 'unset',
    opacity: '0.7',
    cursor: 'pointer',
    fontSize: theme.size.base,

    [theme.breakpoints.down(bp)]: {
      fontSize: theme.size.xl
    }
  },

  back: {
    position: 'absolute',
    top: 10,
    left: '1rem',
    opacity: '0.7',
    cursor: 'pointer',
    fontSize: theme.size.base,

    [theme.breakpoints.down(bp)]: {
      right: 'unset',
      left: '1rem',
      fontSize: theme.size.xl
    }
  },

  title: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: '0.5rem',
    borderBottom: '0.125rem solid #F1F1F1',
    boxSizing: 'border-box',
    paddingBottom: '1.5rem',
    fontSize: theme.size.base,
    color: theme.palette.primary.main
  },

  children: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    maxHeight: 'calc(100% - 2.5rem)',
    paddingRight: '1.5rem',
    overflow: 'hidden auto'
  }
}))

export default useStyles
